
document.addEventListener('DOMContentLoaded', function () {
  let megaMenusInitialized = false;

  function loadMegaImages(container) {
    if (!container) return;

    container.querySelectorAll('img[data-src]').forEach(img => {
      if (!img.dataset.loaded) {
        img.src = img.dataset.src;
        img.dataset.loaded = 'true';
      }
    });
  }

  function initMegaMenus() {
    if (megaMenusInitialized) return;
    megaMenusInitialized = true;

    document.querySelectorAll('.mega-menu').forEach((megaMenu) => {
      const level1Links = megaMenu.querySelectorAll('.menu-panel-1 .has-icon');
      const panel2 = megaMenu.querySelector('.menu-panel-2');
      const panel2Menus = panel2 ? panel2.querySelectorAll('[data-value]') : [];
      const panel3 = megaMenu.querySelector('.menu-panel-3');
      const panel3Menus = panel3 ? panel3.querySelectorAll('[data-value]') : [];
      const level2Links = megaMenu.querySelectorAll('.menu-panel-2 .has-icon');

      function resetPanel2() {
        panel2Menus.forEach(m => m.classList.add('hidden'));
        panel2?.classList.remove('active');
        level1Links.forEach(l => l.classList.remove('active'));
      }

      function resetPanel3() {
        panel3Menus.forEach(m => m.classList.add('hidden'));
        panel3?.classList.remove('active');
        level2Links.forEach(l => l.classList.remove('active'));
      }

      level1Links.forEach(link => {
        link.addEventListener('mouseenter', function () {
          const target = this.dataset.target;
          resetPanel3();

          if (!target) {
            resetPanel2();
            return;
          }

          const targetMenu = panel2?.querySelector(`[data-value="${target}"]`);

          level1Links.forEach(l => l.classList.remove('active'));
          panel2Menus.forEach(m => m.classList.add('hidden'));

          if (targetMenu) {
            this.classList.add('active');
            panel2.classList.add('active');
            targetMenu.classList.remove('hidden');

            
            loadMegaImages(targetMenu);
          } else {
            resetPanel2();
          }
        }, { passive: true });
      });


      level2Links.forEach(link => {
        link.addEventListener('mouseenter', function () {
          const target = this.dataset.target;

          if (!target) {
            resetPanel3();
            return;
          }

          this.closest('ul')
            ?.querySelectorAll('.has-icon')
            .forEach(l => l.classList.remove('active'));

          this.classList.add('active');
          panel3Menus.forEach(m => m.classList.add('hidden'));

          const targetMenu = panel3?.querySelector(`[data-value="${target}"]`);

          if (targetMenu) {
            targetMenu.classList.remove('hidden');
            panel3.classList.add('active');

            
            loadMegaImages(targetMenu);
          } else {
            resetPanel3();
          }
        }, { passive: true });
      });

      megaMenu.querySelectorAll('.accordion-toggle').forEach(btn => {
        const parentLi = btn.closest('li');
        const submenu = parentLi?.querySelector('.submenu');
        const link = parentLi?.querySelector('a.has-icon');

        if (!submenu || !submenu.children.length) {
          btn.style.display = 'none';
          return;
        }

        const indicator = document.createElement('span');
        indicator.className = 'accordion-indicator';
        indicator.textContent = '+';
        indicator.style.color = '#441c41';
        parentLi.appendChild(indicator);

        function toggleAccordion(e) {
          e?.preventDefault();
          e?.stopPropagation();

          parentLi.parentElement.querySelectorAll('li').forEach(li => {
            if (li !== parentLi) {
              li.querySelector('.accordion-toggle')?.classList.remove('active');
              const sm = li.querySelector('.submenu');
              const ind = li.querySelector('.accordion-indicator');
              if (sm) {
                sm.style.maxHeight = '0px';
                sm.classList.remove('open');
              }
              if (ind) ind.textContent = '+';
            }
          });

          btn.classList.toggle('active');

          if (submenu.classList.contains('open')) {
            submenu.style.maxHeight = '0px';
            submenu.classList.remove('open');
            indicator.textContent = '+';
          } else {
            submenu.classList.add('open');
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
            indicator.textContent = '−';

         
            loadMegaImages(submenu);
          }
        }

        if (link && link.getAttribute('href') !== '#') {
          link.dataset.originalHref = link.getAttribute('href');
          link.setAttribute('href', '#');
        }

        indicator.addEventListener('click', toggleAccordion);
        btn.addEventListener('click', toggleAccordion);

        submenu.querySelectorAll('.submenu-link').forEach(subLink => {
          subLink.addEventListener('click', e => {
            e.stopImmediatePropagation();
            e.stopPropagation();

            const href = subLink.getAttribute('href');
            if (href && href !== '#') {
              closeMegaMenu();
              setTimeout(() => (window.location.href = href), 50);
            }
          }, { capture: true });
        });

        parentLi.classList.add('has-accordion');
        submenu.classList.add('accordion-content');
      });

      megaMenu.querySelector('.menu-panel-1 .menu-close')
        ?.addEventListener('click', closeMegaMenu);

      megaMenu.querySelector('.menu-panel-2 .menu-close')
        ?.addEventListener('click', () => {
          resetPanel2();
          resetPanel3();
        });

      megaMenu.addEventListener('click', e => e.stopPropagation());
    });
  }

  function closeMegaMenu() {
    document.querySelectorAll('.mega-menu').forEach(m => m.classList.remove('active'));
    document.querySelectorAll('a[href^="#"].active').forEach(a => a.classList.remove('active'));
    document.getElementById('mega-menu-overlay')?.classList.remove('active');
  }

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('a[href^="#"]');
    if (!trigger) return;

    const targetMenu = document.querySelector(
      `.mega-menu[data-trigger="${trigger.getAttribute('href')}"]`
    );
    if (!targetMenu) return;

    e.preventDefault();
    if (!megaMenusInitialized) initMegaMenus();

    if (targetMenu.classList.contains('active')) {
      closeMegaMenu();
      return;
    }

    closeMegaMenu();
    trigger.classList.add('active');
    targetMenu.classList.add('active');

    
    loadMegaImages(targetMenu);

    document.getElementById('mega-menu-overlay')?.classList.add('active');
  });

  document.getElementById('mega-menu-overlay')
    ?.addEventListener('click', closeMegaMenu);

  const megaMenus = document.querySelectorAll('.mega-menu');
  const mainMenu = document.querySelector('nav.megamenu');

  window.addEventListener('scroll', () => {
    const scrolled = window.scrollY > 50;
    megaMenus.forEach(m => m.classList.toggle('scrolled', scrolled));
    mainMenu?.classList.toggle('scrolled', scrolled);
  }, { passive: true });
});
